<template>
	<div v-loading.fullscreen.lock="fullscreenLoading" element-loading-background="rgba(122, 122, 122, 0.5)" v-if="$store.state.activateStatus">
		<div class="ld-panel-title">
			<h2 class="back-btn">实例列表</h2>
		</div>
		<div class="ld-panel-main">
			<el-button type="primary" @click="buyClick">购买实例</el-button>
			<div class="input-select" style="margin-left: 12px;">
				<el-select v-model="expiredType" style="width: 100px;margin-right: 12px;" @change="endChange">
					<el-option label="全部" value="0" />
					<el-option label="正常" value="1" />
					<el-option label="近7天过期" value="2" />
					<el-option label="已过期" value="3" />
				</el-select>
				<el-input
				  v-model="searchInput"
				  placeholder="请输入搜索关键词..."
				  class="input-with-select"
				  clearable 
				  @clear="handleEmpty"
				  style="width: 400px;"
				>
				  <template #prepend>
					<el-select v-model="searchType" style="width: 100px">
						<el-option label="IP地址" value="3" />
						<el-option label="实例名称" value="1" />
						<el-option label="运行状态" value="2" />
					</el-select>
				  </template>
				  <template #append>
					  <el-button @click="searchClick"></el-button>
				  </template>
				</el-input>
			</div>
			<div class="head-config">
				<span class="settings" @click="dialogtableHeadVisible = true"></span>
				<span class="reload" @click="reloadChange"></span>
			</div>
			<el-alert title="重要提示: 如需修改Memcached实例密码之外的配置，请提交工单处理！" type="warning" show-icon :closable="false" style="margin-bottom: 20px;" />
			<el-table :data="tableData" v-loading="loading" style="width: 100%">
				<el-table-column label="实例名称" v-if="tableHeadObject.tableColumn1">
					<template #default="scope">
						<el-text type="primary" v-if="scope.row.readable_status == '运行中'" @click="rowOperation(scope.row,'detail')" style="cursor: pointer;">{{scope.row.instance_name}}</el-text>
						<el-text type="primary" v-else>{{scope.row.instance_name}}</el-text>
					</template>
				</el-table-column>
				<el-table-column prop="spec" label="规格" v-if="tableHeadObject.tableColumn2" />
				<el-table-column label="监控" width="80" v-if="tableHeadObject.tableColumn3">
					<template #default="scope">
						<span @click="rowOperation(scope.row,'detail')" class="monitor"></span>
					</template>
				</el-table-column>
				<el-table-column label="IP地址" v-if="tableHeadObject.tableColumn4">
					<template #default="scope">
						<span :style="scope.row.readable_status == '已删除' ? 'text-decoration: line-through; color:#999':''">{{scope.row.ip_port}}</span>
					</template>
				</el-table-column>
				<el-table-column label="开始时间/结束时间" width="160" v-if="tableHeadObject.tableColumn5">
					<template #default="scope">
						<div>{{scope.row.create_time}}</div>
						<div>{{scope.row.expiration_time}}</div>
						<el-text type="primary" size="small" v-if="scope.row.rest_days !== ''">{{scope.row.rest_days}}</el-text>
					</template>
				</el-table-column>
				<el-table-column label="运行状态" v-if="tableHeadObject.tableColumn6">
					<template #default="scope">
						<span class="run-status" v-if="scope.row.readable_status == '运行中'">{{scope.row.readable_status}}</span>
						<span class="try-status" v-else-if="scope.row.readable_status == '创建中'">{{scope.row.readable_status}}</span>
						<span class="stop-status" v-else-if="scope.row.readable_status == '待支付'">{{scope.row.readable_status}}</span>
						<span class="stop-status" v-else-if="scope.row.readable_status == '已过期'">{{scope.row.readable_status}}</span>
						<span class="info-status" v-else>{{scope.row.readable_status}}</span>
					</template>
				</el-table-column>
				<el-table-column label="实例类型" v-if="tableHeadObject.tableColumn7">
					<template #default="scope">
						<el-tag>{{scope.row.instance_type_name}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="version" label="实例版本" v-if="tableHeadObject.tableColumn8" />
				<el-table-column prop="instance_desc" label="实例备注" show-overflow-tooltip width="160" v-if="tableHeadObject.tableColumn9" />
				<el-table-column label="操作" width="150" v-if="tableHeadObject.tableColumn10">
				  <template #default="scope">
					<el-button link type="primary" size="small" @click="rowOperation(scope.row,'detail')" v-if="scope.row.readable_status == '运行中'">详情</el-button>
					<el-button link type="danger" size="small" @click="rowOperation(scope.row,'delete')" v-if="scope.row.readable_status == '已过期'">立即释放</el-button>
					<div v-if="scope.row.readable_status == '运行中'">
						<el-button link type="primary" size="small" @click="rowOperation(scope.row,'upgrade')">升级</el-button>
						<el-button link type="primary" size="small" @click="rowOperation(scope.row,'delay')">续费</el-button>
						<el-dropdown class="dropdown-main" size="small" trigger="click" @command="rowOperationMore($event,scope.row)">
							<span class="el-dropdown-link">更多<el-icon class="el-icon--right"><arrow-down /></el-icon></span>
							<template #dropdown>
								<el-dropdown-menu>
									<el-dropdown-item command="pwd">修改密码</el-dropdown-item>
									<el-dropdown-item command="start">重启</el-dropdown-item>
									<el-dropdown-item command="auto">自动续费</el-dropdown-item>
								</el-dropdown-menu>
							</template>
						</el-dropdown>
					</div>
				  </template>
				</el-table-column>
			</el-table>
			<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
		</div>
		<!-- 修改密码 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogPwdVisible" title="修改密码">
			<el-alert title="重要提示: 默认用户名为root" type="warning" show-icon :closable="false" style="margin-bottom: 20px;" />
			<el-form :rules="rulesPwd" ref="rulePwdRef" :model="pwdForm" :label-width="formLabelWidth">
				<el-form-item label="新密码" prop="instance_password">
					<el-input v-model="pwdForm.instance_password" type="password" show-password minlength="8" autocomplete="off" />
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetPwd(rulePwdRef)">取消</el-button>
					<el-button type="primary" @click="submitPwd(rulePwdRef)">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 自动续费 -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogAutoVisible" title="自动续费">
			<el-alert title="温馨提示：" type="warning" :closable="false" style="margin-bottom: 20px;">
				<template #default>
					<p>1、设置成功后，系统自动以1个月时长进行续费，并将于次日开始的第一个扣款日进行扣款；</p>
					<p>2、自动续费于产品到期前自然日7天，3天，2天以及到期当天为扣款日；</p>
					<p>3、每天只扣款一次，扣款成功或者4个扣款日都失败当月不再扣费，请保持账户余额充足；</p>
					<p>4、如您在扣款日前人工手动续费，则当月不再自动续费；</p>
					<p>5、自动续费仅支持账户余额扣款，暂不支持代金券扣款。</p>
				</template>
			</el-alert>
			<el-form :label-width="formLabelWidth">
				<el-form-item label="开启自动续费">
					<el-switch v-model="autoStatus" />
				</el-form-item>
				<el-form-item label="续费时长">
					<el-select v-model="autoRenewal">
						<el-option v-for="item in autoRenewalOptions" :key="item.months" :value="item.months" :label="item.readable_time"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="resetAuto">取消</el-button>
					<el-button type="primary" @click="submitAuto">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- tablehead -->
		<el-dialog width="700" :show-close="false" :close-on-click-modal="false" v-model="dialogtableHeadVisible" title="自定义表头项">
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn1" label="实例名称" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn2" label="规格" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn3" label="监控" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn4" label="IP地址" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn5" label="开始时间/结束时间" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn6" label="运行状态" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn7" label="实例类型" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn8" label="实例版本" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn9" label="实例备注" size="large" /></div>
			<div class="setting-item"><el-checkbox v-model="tableHeadObject.tableColumn10" label="操作" size="large" /></div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="reloadChange">取消</el-button>
					<el-button type="primary" @click="submitSetting">提交</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 验证码 -->
		<el-dialog align-center v-model="captchaVisible" title="验证码" width="380">
			<el-alert :title="alertText" type="warning" show-icon :closable="false" />
			<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style=" width: 240px; display: block;margin:15px auto;cursor: pointer;" />
		    <el-form>
		      <el-form-item label="图片验证码">
		        <el-input v-model="captchaAnswer" autocomplete="off" placeholder="请输入图片中的验证码" style="width: 145px; margin-right: 8px;" />
				<el-button type="primary" :disabled="codeSend" @click="captchaClick">{{codeSendText}}</el-button>
		      </el-form-item>
			  <el-form-item label="短信验证码">
			    <el-input v-model="smsCode" autocomplete="off" placeholder="请输入手机收到的验证码" style="width: 95%;" />
			  </el-form-item>
		    </el-form>
		    <template #footer>
		      <div class="dialog-footer">
		        <el-button type="primary" @click="pwdResetSubmit">确定</el-button>
		      </div>
		    </template>
		</el-dialog>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onMounted } from 'vue';
	import {useStore} from 'vuex';
	import { useRouter } from 'vue-router';
	import pageList from '../../components/pageList.vue'
	import { fetchList,deleteList,setPwd,restart,delaySpec,autoRenewalSubmit } from '@/api/host';
	import { captchaGet,smsCodeGet } from '@/api/home';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { ArrowDown,CopyDocument } from '@element-plus/icons-vue'
	
	const hostDomain = inject('hostDomain');
	const store = useStore()
	const router = useRouter();
	const fullscreenLoading = ref(false);
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const searchType = ref('3');
	const expiredType = ref('0');
	const searchInput = ref('');
	const formLabelWidth = ref('150');
	const dialogAutoVisible = ref(false);
	const autoStatus = ref(false);
	const autoRenewal = ref(0);
	const autoRenewalOptions = ref();
	const dialogPwdVisible = ref(false);
	const instance_id = ref('');
	const tableData = ref();
	const captchaVisible = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const codeSendText = ref('短信验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const smsCode = ref('');
	const alertText = ref('');
	const dialogtableHeadVisible = ref(false);
	const tableHeadObjectDefault = ref({
	  tableColumn1: true,
	  tableColumn2: true,
	  tableColumn3: true,
	  tableColumn4: true,
	  tableColumn5: true,
	  tableColumn6: true,
	  tableColumn7: true,
	  tableColumn8: true,
	  tableColumn9: true,
	  tableColumn10: true
	});
	const tableHeadObject = ref({
	  tableColumn1: true,
	  tableColumn2: true,
	  tableColumn3: true,
	  tableColumn4: true,
	  tableColumn5: true,
	  tableColumn6: true,
	  tableColumn7: true,
	  tableColumn8: true,
	  tableColumn9: true,
	  tableColumn10: true
	});
	const rulePwdRef = ref(null);
	const pwdForm = ref({instance_password:''})
	const passValidate = (rule, value, callback) => {
	  if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@%^*])[^#&$~)(_+=,`.'}{|:";\\[?><]{8,16}$/.test(value)) {
	    callback()
	  }else{
	  	callback(new Error('请输入包含英文字母大小写、数字和特殊符号（! @ % ^ *）的 8-16 位组合'))
	  }
	};
	const rulesPwd = reactive({
		instance_password: [
			{ required: true, message: '请填写密码', trigger: 'blur' },
			{ min: 8, message: '密码长度不小于8位', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		]
	});
	
	
	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'instance_name':searchInput.value,
			'search_type':parseInt(searchType.value),
			'expired_type':parseInt(expiredType.value)
		}
		fetchList(param).then((res) => {
			paginationTotal.value = res.data.total;
			tableData.value = res.data.list;
			loading.value = false;
		})
	};
	const rowOperation = (row, now) => {
		if(now == 'detail'){
			router.push({ path: '/hosts/detail',query: { id: row.instance_id} })
		}
		if(now == 'delete'){
			const param = {"instance_id": row.instance_id}
			ElMessageBox.confirm(
				'确定执行此操作么？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				deleteList(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
		if(now == 'delay'){
			router.push({ path: '/hosts/delay',query: { id: row.instance_id } })
		}
		if(now == 'upgrade'){
			router.push({ path: '/hosts/upgrade',query: { id: row.instance_id } })
		}
	};
	const rowOperationMore = (now, row) => {
		if(now == 'pwd'){
			dialogPwdVisible.value = !dialogPwdVisible.value;
			pwdForm.value.instance_password = row.instance_password;
			instance_id.value = row.instance_id;
		}
		if(now == 'auto'){
			fullscreenLoading.value = true;
			instance_id.value = row.instance_id;
			const param = {'instance_id':row.instance_id}
			delaySpec(param).then((res) => {
				if (res.code == 200) {
					autoRenewalOptions.value = res.data.options;
					autoStatus.value = row.auto_renewal_months == 0 ? false : true;
					autoRenewal.value = row.auto_renewal_months == 0 ? res.data.options[0].months : row.auto_renewal_months;
					dialogAutoVisible.value = !dialogAutoVisible.value;
				}
				fullscreenLoading.value = false;
			});
		}
		if(now == 'start'){
			const param = {"instance_id": row.instance_id}
			ElMessageBox.confirm(
				'确认要重启吗？',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					showClose:false,
					type: 'warning',
				}
			)
			.then(() => {
				fullscreenLoading.value = true;
				restart(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							type: 'success',
							message: res.msg,
						})
						fetchListF()
					}
					fullscreenLoading.value = false;
				})
			})
			.catch(() => {
				
			})
		}
	}
	const submitAuto = () => {
		const param = {'instance_id':instance_id.value};
		param['auto_renewal_months'] = autoStatus.value ? autoRenewal.value : 0;
		autoRenewalSubmit(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				resetAuto();
				fetchListF();
			}
		})
	}
	const captchaChange = () => {
		captchaGet().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const captchaReload = () => {
		captchaChange()
	}
	const submitPwd = () => {
		if (!rulePwdRef.value) return;
		rulePwdRef.value.validate((valid) => {
			if (valid) {
				captchaChange()
				captchaAnswer.value = '';
				captchaId.value = '';
				smsCode.value = '';
				captchaVisible.value = !captchaVisible.value;
			} else {
			  return false;
			}
		});
	};
	const captchaClick = () => {
		const param = {
			'captcha_answer':captchaAnswer.value,
			'captcha_id':captchaId.value
		}
		smsCodeGet(param).then((res) => {
			if (res.code == 200) {
				codeSend.value = true;
				codeSendText.value = codeTime.value+'s后重新发送';
				let timer = setInterval(() => {
				   codeTime.value--;
				   codeSendText.value = codeTime.value + 's后重新发送';
				   if (codeTime.value < 0) {
					   clearInterval(timer);
					   codeSendText.value = '获取验证码';
					   codeTime.value = 60;
					   codeSend.value = false
				   }
				}, 1000)
			}
		})
	}
	const pwdResetSubmit = () => {
		fullscreenLoading.value = true;
		pwdForm.value.instance_id = instance_id.value;
		pwdForm.value.sms_code = smsCode.value;
		const param = pwdForm.value;
		setPwd(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				captchaVisible.value = !captchaVisible.value;
				resetPwd()
				fetchListF();
			}
			fullscreenLoading.value = false;
		})
	}
	const resetPwd = () => {
		pwdForm.value = {instance_password:''};
		rulePwdRef.value.resetFields();
		dialogPwdVisible.value = !dialogPwdVisible.value;
	}
	const resetAuto = () => {
		dialogAutoVisible.value = !dialogAutoVisible.value;
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const endChange = (val) => {
		expiredType.value = val;
		fetchListF()
	};
	const searchClick = () => {
		fetchListF();
	};
	const handleEmpty = () => {
		fetchListF();
	};
	const submitSetting = () => {
		localStorage.setItem('memcachedThead', JSON.stringify(tableHeadObject.value));
		dialogtableHeadVisible.value = false;
	}
	const reloadChange = () => {
		location.reload()
	}
	
	const buyClick = () => {
		window.location.href = hostDomain + "/#/pay";
	};
	
	
	onMounted(() => {
	    fetchListF()
		tableHeadObject.value = localStorage.getItem('memcachedThead') != null ? JSON.parse(localStorage.getItem('memcachedThead')) : tableHeadObjectDefault.value;
		alertText.value = '提示：接收验证码的手机号码为 ' + localStorage.getItem('smsPhone');
	})
	
			
</script>

<style lang="scss" scoped>
	.monitor {
	    width: 20px;
	    height: 20px;
	    display: inline-block;
	    position: relative;
	    vertical-align: middle;
	    cursor: pointer;
		background: url(../../assets/images/monitor.png) center no-repeat;
	}
	.monitor:hover {
		background: url(../../assets/images/monitor-h.png) center no-repeat;
	}
</style>